import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem } from '../../../../shared'
import { GreaseFluidRequest } from '../grease-fluid-request.model'

@Component({
    selector: 'app-grease-fluid-request-form',
    templateUrl: './grease-fluid-request-form.component.html',
    styleUrls: ['./grease-fluid-request-form.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class GreaseFluidRequestFormComponent {
    greaseFluidRequest = input.required<GreaseFluidRequest>()
    jobOptions = input<ListItem<string>[]>([])
    employeeOptions = input<ListItem<number>[]>([])
    equipmentOptions = input<ListItem<string>[]>([])
}
